import config from 'config';
import { handleErrors } from 'api/util';

export async function apiGetIndustryCodes(): Promise<Response> {
    return await fetch(`${config.backendUrl}/industry`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    }).then(handleErrors);
}

export async function apiGetIndustryKeyFigureAggregations(
    industryCode: string
): Promise<Response> {
    industryCode = industryCode === '*' ? 'all' : industryCode;
    return await fetch(
        `${config.backendUrl}/industry/${industryCode}/keyfigure-aggregations`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    ).then(handleErrors);
}
